import { Mission } from '../objects/Mission';
import { ResourceEndpoint } from './ResourceEndpoint';

export class MissionEndpoint extends ResourceEndpoint {
    constructor(url, api) {
        super(url, api, Mission);
    }

    updateMultiple(missionUpdate) {
        var dst = this.url + '/multiple';
        return this._api.putResponse(dst, missionUpdate).then(rsp => rsp.createEmptyResponse());
    }

    updateSorting(sortUpdate) {
        var dst = this.url + '/sorting';
        return this._api.putVoid(dst, sortUpdate);
    }
}
